import { RuntimeConfig } from "nuxt/schema";
import { autoDetectAffiliateUrlFormatter } from "~/utils/formatters/affiliate.url.formatter";
import { ProductDetailType } from "~/types/shop/ProductDetailType";
import { ProductCategoryEntity } from "~/entities/shop/ProductCategoryEntity";
import { RatingEntity } from "~/entities/shop/RatingEntity";
import { contentAutoMapper } from "~/utils/mappers/content.mapper";
import { autoDetectAffiliateSourceFormatter } from "~/utils/formatters/affiliate.source.formatter";

export const ProductDetailEntity = function (data: any, config: RuntimeConfig): ProductDetailType {
    return {
        title: data?.attributes?.title,
        subTitle: data?.attributes?.sub_title,
        category: ProductCategoryEntity(data?.attributes?.product_category?.data),
        slug: data?.attributes?.slug,
        price: data?.attributes?.price,
        oldPrice: data?.attributes?.old_price,
        images: data?.attributes?.images?.data
            .map(image => config.public.ssrMediaBaseUrl + image?.attributes?.url),
        totalRating: Number(data?.attributes?.total_rating),
        ratings: data?.attributes?.ratings?.map(rating => RatingEntity(rating)),
        buyUrl: autoDetectAffiliateUrlFormatter(data?.attributes?.buy_url, config),
        source: autoDetectAffiliateSourceFormatter(data?.attributes?.buy_url),
        content: data.attributes?.content?.map(content => contentAutoMapper(content, config)),
        url: `/shop/product-${data?.attributes?.slug}`,
        error: undefined,
    };
};